angular.module('impactx.cscontract').controller('CSCCommonRelationListCtrl', [
    'selectedListItems',
    '$routeParams',
    CSCCommonRelationListCtrl
]);

function CSCCommonRelationListCtrl(selectedListItems, $routeParams) {
    var self = this;

    self.getDetailLink = function () {
        return 'csccommonrelation/' + selectedListItems.getFirstSelectedItem().comId + '/' + $routeParams.id;
    }

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: self.getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'ViewCSC'
        }
    ];

    self.meta = {
        rowTemplate: 'modules/cscontract/templates/csccommonrelationlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: self,
        endpoint: '/cscontract/basiccontract/relationlist',
        id: "cscCommonRelationList",
        excelExport: true,
        buttonDefinition: buttonDefinition,
        params: {'csccommonId': $routeParams.id},
        mainAction: {id: 'new', link: '#/csccommonrelation/0/'+$routeParams.id, icon: 'mdi-plus'}
    };
    self.getMeta = function () {
        return self.meta;
    };
}